import React, { useState, useEffect } from "react";
import { Tabs, Row, Col } from "antd";
import CustomerMainLayout from "../CustomerMainLayout";
import FileConstants from "../../../../FileConstants";
import CustomerProductReports from "./CustomerProductReports";
import CustomerSpaceReports from "./CustomerSpaceReports";
import UserDetails from "./UserDetails";
import InvitedCustomers from "../../AdminComponents/AdminSalesFunnel/InvitationSent";
import AccountDetails from "./AccountDetails";

const { TabPane } = Tabs;

const MANAGED_CUSTOMER_USERNAME = FileConstants.MANAGED_CUSTOMER_USERNAME;
const IS_MS_PROVIDER = FileConstants.isMSProvider;
const MANAGED_COMPANY_ID = FileConstants.MANAGED_COMPANY_ID;
const USERNAME = localStorage.getItem('username');

const CustomerReports = () => {
  const [invitationCount, setInvitedSizeCount] = useState('');
  return (
    <>
      <CustomerMainLayout selected={"18"} color={true}>
        <Row style={{ marginTop: 30, marginBottom: 30 }} gutter={24}>
            <Col lg={10} xl={10}>
                <div
                  className="manrope f-24 w-700"
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                }}>
                  {MANAGED_CUSTOMER_USERNAME ? `Model Details for ${MANAGED_CUSTOMER_USERNAME}` : 'Model Details'}
                </div>
            </Col>
        </Row>
        <Tabs
          defaultActiveKey="1"
          size="small"
          tabBarStyle={{ textAlign: "center" }}
          animated={false}
          tabBarGutter={32}>
          <TabPane tab="Products" key="1" style={{ color: "#000000" }}>
            <CustomerProductReports />
          </TabPane>

          <TabPane tab="Spaces" key="2" style={{ color: "#000000" }}>
            <CustomerSpaceReports />
          </TabPane>

          <TabPane tab="Company Users" key="3" style={{ color: "#000000" }}>
            <UserDetails />
          </TabPane>

          <TabPane tab="Invited Users" key="4" style={{ color: "#000000" }}>
            <InvitedCustomers  setInvitedSizeCount={setInvitedSizeCount}
            selectedManagers={USERNAME} />
          </TabPane>

          <TabPane tab="Account Detail" key="5" style={{ color: "#000000" }}>
            <AccountDetails />
          </TabPane>
        </Tabs>
      </CustomerMainLayout>
    </>
  );
};

export default CustomerReports;